import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import Home from "@/pages/home/page";

// Les pages secondaires sont chargées en différé (code-splitting) pour
// alléger le bundle initial de la page d'accueil.
const Realisations = lazy(() => import("@/pages/realisations/page"));
const QuiSommesNous = lazy(() => import("@/pages/qui-sommes-nous/page"));
const ImpactSiteInternet = lazy(() => import("@/pages/impact-site-internet/page"));
const Contact = lazy(() => import("@/pages/contact/page"));
const MentionsLegales = lazy(() => import("@/pages/mentions-legales/page"));
const CGV = lazy(() => import("@/pages/cgv/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  {
    path: "/realisations",
    element: (
      <Suspense fallback={null}>
        <Realisations />
      </Suspense>
    ),
  },
  {
    path: "/qui-sommes-nous",
    element: (
      <Suspense fallback={null}>
        <QuiSommesNous />
      </Suspense>
    ),
  },
  {
    path: "/impact-site-internet",
    element: (
      <Suspense fallback={null}>
        <ImpactSiteInternet />
      </Suspense>
    ),
  },
  {
    path: "/contact",
    element: (
      <Suspense fallback={null}>
        <Contact />
      </Suspense>
    ),
  },
  {
    path: "/mentions-legales",
    element: (
      <Suspense fallback={null}>
        <MentionsLegales />
      </Suspense>
    ),
  },
  {
    path: "/cgv",
    element: (
      <Suspense fallback={null}>
        <CGV />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={null}>
        <NotFound />
      </Suspense>
    ),
  },
];

export default routes;